import '@src/assets/styles/empty.scss';

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import nextStartDate from '@utils/nextStartDate';
dayjs.extend(duration)

const countDownTimer = () => {

  const startCountDown = (el) => {
    if (!el.classList.contains('started')) {
      el.classList.add('started');

      const updateTimer = (el) => {
        const eventTime = new nextStartDate().value();
        const currentTime = dayjs();
        const diffTime = eventTime.diff(currentTime);

        let remainder;

        if (diffTime < 0) {
          remainder = dayjs.duration(diffTime).add(1,'day');
        } else {
          remainder = dayjs.duration(diffTime);
        }

        
        const html = `<div class='digit'>
              <div class='value'>${remainder.days() + remainder.months() * 30}</div>
              <div class='label'>days</div>
            </div>
            <div class='digit'>
              <div class='value'>${remainder.hours()}</div>
              <div class='label'>hours</div>
            </div>
            <div class='digit'>
              <div class='value'>${remainder.minutes()}</div>
              <div class='label'>minutes</div>
            </div>
            <div class='digit'>
              <div class='value'>${remainder.seconds()}</div>
              <div class='label'>seconds</div>
            </div>`;

        el.innerHTML = html;
      }

      updateTimer(el);

      window.setInterval(() => {
        updateTimer(el);
      }, 1000)
    }

  }

  Array.prototype.forEach.call(document.getElementsByClassName("count-down-timer"), function (el) {
    startCountDown(el)
  });
}

var injectMenu = function () {
  // var htmlString = "";
  // [
  //   { name: 'overview', label: 'Overview' },
  //   { name: 'curriculum', label: 'Curriculum' },
  //   { name: 'datesAndTuition', label: 'Date & Tuition' },
  //   { name: 'careerGuidance', label: 'Career Guidance' },
  //   { name: 'mentorship', label: '1-on-1 Mentorship' },
  //   { name: 'schedule', label: 'Self-paced Schedule' },
  //   { name: 'prereqs', label: 'Prerequisite' },
  //   { name: 'faqs', label: 'FAQs' },
  // ].forEach(function(item) {

  //   htmlString += `<a href="#${item.name}" id="${item.name}-nav-button" class="nav-link p-0">
  //     <div class="menuItem">${item.label}</div>
  //   </a>`
  // })

  // document.querySelector('#sideMenuContainer .nav').innerHTML = htmlString;
  
  var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var offset = width < 992 ? 89 : 43;

  $('body').scrollspy({ target: '#side-menu-nav', offset })

  var adjustMenuPosition = function () {

    var sideMenuWrapper = document.getElementById('sideMenuWrapper');

    window.requestAnimationFrame(() => {
      const heroContainer = document.getElementById('heroContainer');
      const topBanner = document.getElementById('top-banner');
      const pageOffset = window.pageYOffset;
      const windowHeight = window.innerHeight;
      const pageHeight = document.getElementById('trackPageContainer').scrollHeight;
      const inflectionPoint = heroContainer.scrollHeight + topBanner.scrollHeight;
      const sideMenuWrapperHeight = sideMenuWrapper.scrollHeight;
      const distanceFromBottom = pageHeight - windowHeight - pageOffset + (windowHeight - sideMenuWrapperHeight);

      if (pageOffset >= inflectionPoint) {
        sideMenuWrapper.classList.add("fixed");
      } else {
        if (sideMenuWrapper.classList.contains("fixed")) {
          sideMenuWrapper.classList.remove("fixed");
        }
      }

      if (distanceFromBottom <= 320) {
        sideMenuWrapper.style.position = 'absolute';
        sideMenuWrapper.style.top = 'initial';
        sideMenuWrapper.style.bottom = '320px';
      } else {
        sideMenuWrapper.style.position = '';
        sideMenuWrapper.style.top = '';
        sideMenuWrapper.style.bottom = '';
      }
    });
  }

  window.addEventListener('scroll', adjustMenuPosition, { passive: true });

  // todo implete js smoothscroll and scrollintoview https://css-tricks.com/snippets/jquery/smooth-scrolling/

  // var shouldScrollIntoView = true;

  // window.disableScrollIntoView = function (e) {
  //   e.preventDefault();
  //   console.log('disabled')
  //   shouldScrollIntoView = false;
  //   window.setTimeout(() => {
  //     shouldScrollIntoView = true;
  //   }, 500);
  // }

  // var isElementInViewport = function (el) {

  //     // Special bonus for those using jQuery
  //     if (typeof jQuery === "function" && el instanceof jQuery) {
  //         el = el[0];
  //     }

  //     var rect = el.getBoundingClientRect();

  //     return (
  //         rect.top >= 0 &&
  //         rect.left >= 0 &&
  //         rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
  //         rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  //     );
  // }

  // let timer;
  // window.addEventListener('scroll', () => {
  //   if (timer) {
  //     clearTimeout( timer );
  //   }

  //   timer = setTimeout(() => {
  //     const activeLink = document.querySelector('#side-menu-nav .nav-link.active');
  //     if (activeLink) {
  //       if (!isElementInViewport(activeLink)) {
  //         // activeLink.scrollIntoView();
  //         const menu = activeLink.parentElement;
  //         menu.scrollLeft = activeLink.offsetLeft - 16;
  //       }
  //     }
  //   }, 100 );
  // }, { passive: true } );

  // let ticking = false;

  // window.addEventListener('scroll', (e) => {
  //   if (!ticking) {
  //     window.requestAnimationFrame(() => {
  //       const activeLink = document.querySelector('#side-menu-nav .nav-link.active');
  //       if (activeLink) {
  //         if (!isElementInViewport(activeLink)) {
  //           const menu = activeLink.parentElement;
  //           menu.scrollLeft = activeLink.offsetLeft - 16;
  //         }
  //       }
        
  //       ticking = false;
  //     });

  //     ticking = true;
  //   }
  // }, { passive: true });

  // var scrollTimer = undefined;

  // $(window).on('activate.bs.scrollspy', function (e, obj) {
  //   e.preventDefault();
  //   const button = document.getElementById(`${obj.relatedTarget.slice(1)}-nav-button`);
  //   const menu = button.parentElement;
  //   console.log('activate scroll');
  //   console.log(obj.relatedTarget)
  //   console.log(isElementInViewport(button))
  //   // if (scrollTimer) {
  //   //   window.clearTimeout(scrollTimer);
  //   // }
  //   // scrollTimer = window.setTimeout(() => {
  //     if (!isElementInViewport(button)) {
  //       console.log('not in viewport')
  //         // button.scrollIntoView();
  //         menu.scrollLeft = button.offsetLeft - 16;
  //     }
  //   // }, 800);
  // })
}

window.addEventListener('load', (event) => {
  injectMenu();
  countDownTimer();
});
